export default "__VITE_ASSET__b648766e__"